import * as actionType from "./actionTypes";
import { getRequestAuthed, postRequestAuthed, processError, downloadFileAuthed } from "../../utils/apiHandlers";
import { LOADING_STATE, LS_ITEM_ADMIN, NOTIF_TYPE } from "../../utils/stateTypes";
import _notif from "../notification";
import { adminOrderSelectors } from "../rootSelectors";

const filterQuery = (filters) => (
  `payment=${encodeURIComponent(filters.payment)}&fulfilment=${encodeURIComponent(filters.fulfilment)}&search=${encodeURIComponent(filters.search)}`
);

/* =========================== DASHBOARD =========================== */

export const loadSummary = () => (
  (dispatch) => {
    const lsItem = LS_ITEM_ADMIN.SUMMARY_LOAD;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    getRequestAuthed("/AdminOrder/Summary",
      (summary) => {
        dispatch({ type: actionType.SET_SUMMARY, summary });
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

/* =========================== ORDER LIST =========================== */

export const setFilters = (filters) => (
  {
    type: actionType.SET_FILTERS,
    filters,
  }
);

export const loadOrders = (page=1) => (
  (dispatch, getState) => {
    const lsItem = LS_ITEM_ADMIN.ORDERS_LOAD;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    const filters = adminOrderSelectors.getFilters(getState());
    getRequestAuthed(`/AdminOrder/Orders?${filterQuery(filters)}&page=${page}`,
      (result) => {
        dispatch({ type: actionType.SET_ORDERS, result });
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

export const exportCsv = () => (
  (dispatch, getState) => {
    const lsItem = LS_ITEM_ADMIN.EXPORT;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    const filters = adminOrderSelectors.getFilters(getState());
    downloadFileAuthed(`/AdminOrder/ExportCsv?${filterQuery(filters)}`, "lashbrow-orders.csv")
      .then(() => dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED)))
      .catch(processError(dispatch, _notif, lsItem));
  }
);

/* =========================== SINGLE ORDER =========================== */

const setOrder = (order) => (
  {
    type: actionType.SET_ORDER,
    order,
  }
);

export const loadOrder = (orderID) => (
  (dispatch) => {
    const lsItem = LS_ITEM_ADMIN.ORDER_LOAD;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    getRequestAuthed(`/AdminOrder/Order/${orderID}`,
      (order) => {
        dispatch(setOrder(order));
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

export const saveOrder = (update) => (
  (dispatch) => {
    const lsItem = LS_ITEM_ADMIN.ORDER_SAVE;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    postRequestAuthed("/AdminOrder/UpdateOrder",
      update,
      (order) => {
        dispatch(setOrder(order));
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
        dispatch(_notif.actions.queueNotification("Order saved", NOTIF_TYPE.SUCCESS));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

/* =========================== ACCOUNT =========================== */

export const changePassword = (currentPassword, newPassword, successCB) => (
  (dispatch) => {
    const lsItem = LS_ITEM_ADMIN.PASSWORD_SAVE;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));

    postRequestAuthed("/Account/ChangePassword",
      { currentPassword, newPassword },
      () => {
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
        dispatch(_notif.actions.queueNotification("Password changed", NOTIF_TYPE.SUCCESS));
        successCB();
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);
